@if (type === pageTypeEnum.pdp) {
  <div class="c__wrapper-title">
    @if (title) {
      <p class="c__title brand--h5">{{ title }}</p>
    }
    @if (hasModal) {
      <button sd-button-icon
        type="button"
        class="c__toggle {{isOpened ? 'is-open' : ''}}"
        (click)="openModal()"
        [attr.aria-expanded]="isOpened"
        [size]="iconSizeEnum.xs"
        icon="icon-arrow-right"
      ></button>
    }
  </div>
  <ul class="c__reinsurance-list" role="list">
    @for (reinsurance of reinsurances; track reinsurance.title) {
      <li><sd-html [html]="reinsurance.title" tag="span" /></li>
    }
  </ul>
  <sd-modal-default
    [(isOpened)]="isOpened"
    (isOpenedChange)="isOpenedChange.emit($event)"
    [brand]="brand"
    [clickToClose]="true"
    modalCustomClass="c__reinsurance-modal is-large"
    [titleHidden]="false"
    [modalTitleLevel]="2"
    [modalTitle]="modalContent?.title"
  >
    <div class="c__modal-content row">
      @for (modalReinsurance of modalContent?.reinsurances; track modalReinsurance) {
        <div class="col-l-11 {{$odd ? 'offset-l-1' : ''}}">
          @if (modalReinsurance?.title) {
            <sd-html innerClass="c__modal-content-title" [html]="modalReinsurance?.title" />
          }
          @if (modalReinsurance?.subtitle) {
            <sd-html innerClass="c__modal-content-subtitle" [html]="modalReinsurance?.subtitle" />
          }
          @if (modalReinsurance?.icons?.length) {
            <ul>
              @for (item of modalReinsurance?.icons; track item) {
                <li class="c__modal-content-link">
                  @if (item.link) {
                    <sd-link
                      customClass="is-full-area"
                      [ariaLabel]="item.link?.linkName"
                      [isButton]="true"
                      [isSecondary]="true"
                      (clicked)="onClick(item.link)"
                      [link]="item.link"
                    >
                      <span>{{item.link?.linkName}}</span>
                    </sd-link>
                  }
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
  </sd-modal-default>
}

@if (type !== pageTypeEnum.pdp) {
  @for (reinsurance of reinsurances; track reinsurance.title) {
    <sd-reinsurance
      [data]="reinsurance"
      [isBrand]="isBrand"
      [textThemesConfig]="contentThemesConfig"
      [textConfig]="textConfig"
      [titleLevel]="titleLevel"
      [hasSubline]="hasSubline"
      (clickedReinsurance)="onClick($event)"
    />
  }
}
